module.exports = __webpack_public_path__ + "img/3594ef8.png";